import { MpColumn, MpTableType } from '@mp-react/table';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { CustomRendererType } from '../../types/Table';
import { useTableFilterTypes } from '../../utils/Table';
import { useLocalStorage } from '../../utils/LocalStorage';
import { StorageKeys } from '../../types/LocalStorage';

export const useRecipientsTable = (): MpTableType => {
  const { t } = useTranslation();
  const { keyWithSuffix } = useLocalStorage();

  const { getSelectFilter, getFilterNameSearchSelectFilter, countRangeFilter } =
    useTableFilterTypes();

  const groupNameFilter = useMemo(
    () => getFilterNameSearchSelectFilter('getNames'),
    [getFilterNameSearchSelectFilter],
  );

  const statusFilter = useMemo(
    () =>
      getSelectFilter('acceptanceStatus', [
        {
          value: 'on',
          label: t('status.on'),
        },
        {
          value: 'off',
          label: t('status.off'),
        },
      ]),
    [getSelectFilter, t],
  );

  const columns = useMemo(
    (): MpColumn[] => [
      {
        label: t('groups.group_name'),
        key: 'name',
        filter: groupNameFilter,
      },
      {
        label: t('exportFileName.employees'),
        key: 'employeeCount',
        sort: false,
        filter: countRangeFilter,
      },
      {
        label: t('common.status'),
        key: 'status',
        render: CustomRendererType.switch as any,
        sort: false,
        action: {
          slug: 'toggleRow',
          color: 'primary',
        },
        filter: statusFilter,
      },
    ],
    [countRangeFilter, groupNameFilter, statusFilter, t],
  );

  return {
    columns,
    rowIdKey: 'id',
    filterVariant: 'head',
    storageIdentifier: keyWithSuffix(StorageKeys.recipientsTable),
    cacheFilters: false,
    cacheSorting: false,
    clearColumnFilters: true,
  };
};
